import { inject, InjectionToken } from '@angular/core';
import { PartnerService } from '@galaxy/partner';
import { GetAccountInfoResponse, OwnerType, ParticipantType, SmsApiService } from '@vendasta/smsv2';
import { catchError, filter, map, of, switchMap } from 'rxjs';

export const SmsRegistrationLibraryInjectionToken = new InjectionToken('dependencies given to the sms library', {
  factory: () => {
    const partnerService = inject(PartnerService);
    const smsService = inject(SmsApiService);

    const subAccountId$ = partnerService.getPartnerId().pipe(
      switchMap((partnerId) =>
        smsService.getAccountInfo({
          sender: {
            internalId: partnerId,
            type: ParticipantType.PARTICIPANT_TYPE_PARTNER,
          },
        }),
      ),
      catchError((e) => {
        console.error('error retrieving GetAccountInfo:', e);
        return of({} as GetAccountInfoResponse);
      }),
      filter((accountInfo) => !!accountInfo),
      map((accountInfo) => accountInfo?.subaccountId),
    );

    return {
      ownerId$: partnerService.getPartnerId(),
      ownerType: OwnerType.OWNER_TYPE_PARTNER,
      subaccountID$: subAccountId$,
    };
  },
});
